<!-- BOM匹配详情弹框 -->
<template>
  <div
    class="smt-bom-table"
    ref="tableContainer"
  >
    <el-table
      border
      style="width: 100%"
      :data="bomData || []"
      :cell-class-name="cellClassName"
      :height="600"
    >
      <el-table-column
        label="源需求"
        header-align="center"
        label-class-name="main-header"
      >
        <template slot="header">
          源需求
          <span class="text-gray">（如有确认替换的物料已覆盖源需求）</span>
        </template>
        <el-table-column
          v-for="item in leftList"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
        >
          <!-- v-if="item.key !== 'index'" -->
          <template slot-scope="{ row, $index }">
            <span
              v-if="item.key !== 'index'"
              v-html="highlightKeyword(row[item.key], newKeywords)"
            >
            </span>
            <span v-else>
              {{ $index + 1 }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="已选定的物料"
        label-class-name="main-header"
      >
        <template slot="header">
          已选定的物料
          <span class="text-gray">（华秋工程师不再介入做资料确认）</span>
        </template>
        <el-table-column
          v-for="item in rightList"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span v-html="highlightKeyword(row[item.key], newKeywords)"> </span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    bomData: {
      type: [Array, Object],
      default: [],
    },
    newKeywords: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShow: false,
      leftList: [
        { key: "index", label: "序号", width: 60 },
        { key: "cusLocation", label: "位号", width: 140 },
        { key: "cusEncap", label: "封装", width: 100 },
        { key: "cusGoodsOtherName", label: "规格参数", width: 100 },
        { key: "cusGoodsName", label: "型号", width: 140 },
        { key: "cusBrand", label: "品牌", width: 100 },
        { key: "cusCatName", label: "分类", width: 100 },
        { key: "cusGoodsSn", label: "我的编号", width: 100 },
      ],
      rightList: [
        { key: "itemStatus", label: "选型结果", width: 100 },
        { key: "goodsCode", label: "编码", width: 100 },
        { key: "goodsName", label: "型号", width: 140 },
        { key: "brandName", label: "品牌", width: 100 },
        { key: "encap", label: "封装", width: 100 },
        { key: "goodsDesc", label: "规格描述", width: 100 },
        { key: "dosage", label: "单机用量", width: 80 },
        { key: "loss", label: "备损/差异", width: 85 },
        { key: "dt", label: "交期", width: 120 },
        { key: "totalNum", label: "贴片用量", width: 80 },
        { key: "usageQuantity", label: "选项用量", width: 80 },
        { key: "unitPrice", label: "原单价(含税)", width: 110 },
        { key: "discountUnitPrice", label: "折扣单价(含税)", width: 120 },
        { key: "subtotal", label: "小计", width: 120 },
      ],
    };
  },
  mounted() {
    this.calculateTableHeight();
    // 监听窗口大小变化
    window.addEventListener("resize", this.calculateTableHeight);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.calculateTableHeight);
  },
  methods: {
    close() {
      this.isShow = false;
    },
    // 高亮关键字方法
    highlightKeyword(text, keyword) {
      if (!text || !keyword) return text;

      const textStr = text.toString();
      const keywordStr = keyword.toString();

      // 使用正则表达式进行大小写不敏感的替换
      const regex = new RegExp(
        `(${keywordStr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
        "gi"
      );
      return textStr.replace(regex, '<span class="highlight-text">$1</span>');
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      const { leftList, rightList } = this;
      const leftLen = leftList.length;
      // 序号
      // if (columnIndex === 0) {
      //   return 'bg-grey'
      // }
      // 左边单元格
      // if (columnIndex < leftLen) {
      //   return 'bg-lightGreen'
      // }
      // 右边单元格
      let className = [];
      if (["在华秋购买", "在华秋订购"].includes(row.itemStatus)) {
        // className.push('bg-yellow')
        if (columnIndex >= leftLen) {
          className.push("bg-clearGreen");
        }
      }
      if (column.property === "itemStatus" && row.itemStatus === "不贴") {
        className.push("text-red");
      }
      const textGreyKeys = rightList
        .map((item) => item.key)
        .filter((key) => ["/", "待报价"].includes(row[key]));
      if (textGreyKeys.includes(column.property)) {
        className.push("text-grey");
      }
      return className.join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
$barderColor: #d7d7d7;

.smt-bom-table {
  position: relative;
  height: 100%;
  // 移除 overflow: auto，因为这会阻止 sticky 效果
}

// 精确高亮文本样式
::v-deep .highlight-text {
  background-color: #ffeb3b;
  color: #333;
  font-weight: bold;
  padding: 1px 2px;
  border-radius: 2px;
}

::v-deep .el-table {
  border-color: $barderColor;
  border-right: 1px solid $barderColor;
  font-size: 12px;

  // 确保表格容器可以滚动
  &.el-table--scrollable-y .el-table__body-wrapper {
    overflow-y: auto;
  }

  // 表头吸顶样式
  .el-table__header-wrapper {
    position: sticky !important;
    top: 0 !important;
    z-index: 1000 !important;
    background-color: #ffffff !important;
  }

  // 为表头单元格添加 sticky
  .el-table__header th {
    position: sticky !important;
    top: 0 !important;
    z-index: 999 !important;
    background-color: #f2f2f2; // 确保表头有背景色避免内容穿透
  }
  .main-header {
    background-color: #fff !important;
  }
  th.el-table__cell {
    padding: 0;
    color: #333;
    background-color: #f2f2f2;
    border-color: $barderColor;
  }

  td.el-table__cell {
    padding: 0;
    color: #333;
    border-color: $barderColor;
  }

  .bg-grey {
    background-color: #f2f2f2;
  }

  .bg-clearGreen {
    background-color: #f3fbf8;
  }

  .bg-lightGreen {
    background-color: #f7fcfb;
  }

  .bg-yellow {
    background-color: #ffff80;
  }

  .text-red {
    color: #ff4d4f !important;
  }

  .text-gray {
    color: #a0a0a0 !important;
  }

  .text-grey {
    color: #aaaaaa !important;
  }

  // 表格行高设置
  .el-table__body tr {
    td {
      padding: 6px 0;
    }
  }

  .el-table__header tr {
    th {
      padding: 6px 0;
    }
  }
}
</style>
